import { type FC } from "react";
import { useParams } from "react-router-dom";
import { AbsoluteRoute, type RouteParams } from "../../../../core/routes";
import { CardWithBannerSkeletonContainer } from "../../../dashboard/components/CardWithBannerSkeletonContainer";
import { TitlePane } from "../../dashboard/TitlePane";
import { AppInstallOverview } from "../components/AppInstallOverview";
import { AppOverview } from "../components/AppOverview";
import { useGetAppInfo } from "../hooks/useGetAppInfo";

export const AppDetailsContainer: FC = () => {
    const { orgId, appId } = useParams<RouteParams[AbsoluteRoute.ORG_APP]>();
    const { loading, appInfo, demoGroupId } = useGetAppInfo();

    return (
        <CardWithBannerSkeletonContainer loading={loading}>
            <TitlePane
                title={appInfo.name ?? ""}
                iconUrl={appInfo.iconUrl ?? ""}
                isDetailsPage
                appId={appId}
                organizationId={orgId ?? ""}
                hasApps={Object.keys(appInfo).length > 0}
                platformType={appInfo.platformType}
            />
            <AppOverview />
            <AppInstallOverview
                platformType={appInfo.platformType}
                lensGroupId={demoGroupId}
                stagingApiToken={appInfo?.stageToken ?? ""}
                productionApiToken={appInfo?.prodToken ?? ""}
            />
        </CardWithBannerSkeletonContainer>
    );
};
